module.exports = __webpack_public_path__ + "static/media/Trome.b032a324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/Trome.png
// module id = 537
// module chunks = 0